export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-950">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <span className="inline-block text-xs font-semibold bg-accent-500 text-background-950 px-3 py-1.5 rounded-full mb-4 tracking-wide">
            📩 投稿爆料
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 leading-tight">
            有料你就来 · 一起吃大瓜
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-background-300 max-w-lg mx-auto">
            如果你有独家黑料线索、网红八卦或娱乐圈内幕，欢迎通过以下方式联系我们。所有投稿信息严格保密，爆料人身份绝不公开。黑料最新爆料，也许就来自你的手中。
          </p>

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="p-5 bg-background-800 rounded-lg border border-background-700/50">
              <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-accent-500/20 text-accent-400">
                <i className="ri-mail-line text-xl"></i>
              </div>
              <h3 className="mt-3 text-sm font-semibold text-background-100">邮件投稿</h3>
              <p className="mt-1 text-xs text-background-400">tips@heiliao.com</p>
            </div>
            <div className="p-5 bg-background-800 rounded-lg border border-background-700/50">
              <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-primary-500/20 text-primary-400">
                <i className="ri-wechat-line text-xl"></i>
              </div>
              <h3 className="mt-3 text-sm font-semibold text-background-100">微信爆料</h3>
              <p className="mt-1 text-xs text-background-400">heiliao_tips</p>
            </div>
            <div className="p-5 bg-background-800 rounded-lg border border-background-700/50">
              <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-accent-500/20 text-accent-400">
                <i className="ri-chat-smile-2-line text-xl"></i>
              </div>
              <h3 className="mt-3 text-sm font-semibold text-background-100">私信投稿</h3>
              <p className="mt-1 text-xs text-background-400">微博 @黑料吃瓜网</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}